
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function UslugiPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Navbar />

      {/* Hero */}
      <section className="pt-40 pb-20 px-6 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse at 50% 0%, rgba(0,212,255,0.06) 0%, transparent 60%)' }}
        />
        <div className="max-w-[1200px] mx-auto text-center relative z-10">
          <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-6">Nasze usługi</p>
          <h1 className="text-5xl md:text-7xl font-black mb-8 leading-tight">
            Kompleksowe rozwiązania<br />
            <span className="text-white/40">dla Twojego biznesu</span>
          </h1>
          <p className="text-xl text-white/40 max-w-3xl mx-auto">Od strategii po realizację. Wszystko, czego potrzebujesz, aby wygrać w digital.</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* Strony Premium */}
            <div className="bg-[#0d0d0d] border border-[#00d4ff]/15 rounded-3xl p-12 hover:border-[#00d4ff]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
                <i className="ri-window-line text-3xl text-[#00d4ff]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">Strony WWW Premium</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Projektujemy i budujemy strony internetowe, które nie tylko wyglądają świetnie, ale przede wszystkim sprzedają. Produktowy design, szybkie ładowanie i perfekcyjna konwersja.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Design System Premium — spójny, nowoczesny design dopasowany do Twojej marki', 'Optymalizacja Performance — Core Web Vitals, szybkie ładowanie, perfekcyjne UX', 'Responsywność — idealne wyświetlanie na wszystkich urządzeniach', 'Integracje — CRM, analytics, płatności, automatyzacje'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#00d4ff] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-black px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* SEO */}
            <div className="bg-[#0d0d0d] border border-[#00ff88]/15 rounded-3xl p-12 hover:border-[#00ff88]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(0,255,136,0.1)', border: '1px solid rgba(0,255,136,0.3)' }}>
                <i className="ri-line-chart-line text-3xl text-[#00ff88]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">SEO & Pozycjonowanie Treści</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Widoczność w Google, która przekłada się na realne leady i sprzedaż. Kompleksowa strategia SEO oparta na danych i wynikach.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Audyt Techniczny — analiza i naprawa błędów technicznych SEO', 'Strategia Słów Kluczowych — research i targetowanie najbardziej wartościowych fraz', 'Content Marketing — tworzenie treści pod intencje użytkowników', 'Link Building — budowanie autorytetu domeny'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#00ff88] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-black px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #00ff88, #00dd77)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Agenci AI */}
            <div className="bg-[#0d0d0d] border border-[#ff6b9d]/15 rounded-3xl p-12 hover:border-[#ff6b9d]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(255,107,157,0.1)', border: '1px solid rgba(255,107,157,0.3)' }}>
                <i className="ri-robot-2-line text-3xl text-[#ff6b9d]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">Agenci AI na Stronę</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Inteligentni asystenci, którzy obsługują Twoich klientów 24/7. Automatyzacja, która zwiększa konwersję i redukuje koszty.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Chatboty AI — inteligentne rozmowy z klientami w czasie rzeczywistym', 'Voice Assistants — głosowa obsługa klienta', 'Automatyzacja Procesów — rezerwacje, wyceny, FAQ automatycznie', 'Integracja z CRM — automatyczny zapis leadów i danych'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b9d] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-white px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #ff6b9d, #ff5a8c)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Google Wizytówka */}
            <div className="bg-[#0d0d0d] border border-[#00d4ff]/15 rounded-3xl p-12 hover:border-[#00d4ff]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
                <i className="ri-map-pin-line text-3xl text-[#00d4ff]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">Google Wizytówka & Local SEO</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Dominacja w lokalnych wynikach wyszukiwania. Pojawiaj się tam, gdzie Twoi klienci Cię szukają — w Google Maps i lokalnych wynikach.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Optymalizacja Profilu — kompletna konfiguracja Google Business Profile', 'Zarządzanie Opiniami — budowanie pozytywnego wizerunku online', 'Local Citations — wpisy w katalogach i portalach branżowych', 'Monitoring Pozycji — regularne raporty i optymalizacja'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#00d4ff] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-black px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* 360 */}
            <div className="bg-[#0d0d0d] border border-[#00ff88]/15 rounded-3xl p-12 hover:border-[#00ff88]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(0,255,136,0.1)', border: '1px solid rgba(0,255,136,0.3)' }}>
                <i className="ri-vidicon-line text-3xl text-[#00ff88]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">Wirtualne Wycieczki 360°</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Immersyjne doświadczenia, które pozwalają klientom zwiedzić Twoją przestrzeń bez wychodzenia z domu. Idealne dla hoteli, restauracji, nieruchomości.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Spacery Wirtualne — interaktywne wycieczki 360° po Twojej przestrzeni', 'Integracja z Google Maps — zwiększ widoczność w Google', 'Hotspoty Interaktywne — dodatkowe informacje, linki, multimedia', 'Hosting i Wsparcie — pełna obsługa techniczna'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#00ff88] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-black px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #00ff88, #00dd77)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>

            {/* Dron + Foto */}
            <div className="bg-[#0d0d0d] border border-[#ff6b9d]/15 rounded-3xl p-12 hover:border-[#ff6b9d]/40 transition-all duration-300 hover:-translate-y-1">
              <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-8" style={{ background: 'rgba(255,107,157,0.1)', border: '1px solid rgba(255,107,157,0.3)' }}>
                <i className="ri-camera-3-line text-3xl text-[#ff6b9d]" />
              </div>
              <h2 className="text-3xl font-black text-white mb-4">Dron & Fotografia Profesjonalna</h2>
              <p className="text-white/45 text-base mb-8 leading-relaxed">Spektakularne ujęcia z powietrza i profesjonalna fotografia produktowa. Wizualizacje, które sprzedają.</p>
              <h3 className="text-base font-bold text-white mb-4">Co otrzymujesz:</h3>
              <ul className="space-y-4 mb-8">
                {['Fotografia z Drona — ujęcia lotnicze nieruchomości, terenów, eventów', 'Wideo z Drona — dynamiczne filmy promocyjne 4K', 'Fotografia Produktowa — sesje produktowe pod e-commerce', 'Postprodukcja — obróbka i optymalizacja zdjęć'].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b9d] text-lg mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
              <Link to="/kontakt" className="inline-flex items-center gap-2 text-white px-8 py-4 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer hover:scale-105 transition-transform" style={{ background: 'linear-gradient(135deg, #ff6b9d, #ff5a8c)' }}>
                Umów konsultację <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-32 px-6">
        <div className="max-w-[900px] mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">Nie widzisz swojej usługi?</h2>
          <p className="text-white/40 text-lg mb-10 max-w-2xl mx-auto">Skontaktuj się z nami — stworzymy rozwiązanie dopasowane do Twoich potrzeb.</p>
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 text-black px-10 py-5 rounded-xl font-bold text-lg whitespace-nowrap cursor-pointer hover:scale-105 transition-transform shadow-[0_0_40px_rgba(0,212,255,0.3)]"
            style={{ background: 'linear-gradient(135deg, #00d4ff, #00b8e6)' }}
          >
            Porozmawiajmy o Twoim projekcie
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
